import React, { useState, useEffect } from 'react';
import ActividadEditor from './ActividadEditor';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  setPending,
  deleted,
  setDeletedPending,
  getAllDeleted,
  restore,
  getAllByParent,
} from '../redux/actions/actividadActions';

import { callStatus } from '../utils/constants';
import { Button, Space, Layout, Modal, Tag } from 'antd';
import { withRouter } from 'react-router-dom';

import {
  DeleteFilled,
  SelectOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  SearchOutlined,
  EditFilled,
} from '@ant-design/icons';
import styled from 'styled-components';
import RestorePopup from './RestorePopup';
import MetaTable from './base/MetaTable';
import dayjs from 'dayjs';
import { convertDate } from '../utils/funtions';
import CustomCellRender from './base/CustomCellRender';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const ActividadList = ({
  location,
  stateData,
  establecimiento,
  cultivo,
  dispatch,
  match,
  campanaId,
  parent,
}) => {
  const id = campanaId || (match && match.params ? match.params.id : null);
  const [showRestore, setShowRestore] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  const history = useHistory();

  useEffect(() => {
    dispatch(getAllByParent(id));
    dispatch(setPending());
    // eslint-disable-next-line
  }, []);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleRestore = () => {
    setShowRestore(true);
    getAllDeleted(dispatch);
  };

  const handleRestoreCancel = () => {
    setShowRestore(false);
    dispatch(setDeletedPending());
  };

  const handleRestoreOk = (data) => {
    dispatch(restore({ data: data }));
    setShowRestore(false);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleView = (data) => {
    history.push(`/campanas/${id}/actividades/${data.id}/resumen`);
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const restoreColumns = [
    {
      ellipsis: true,
      title: 'Establecimiento',
      dataIndex: 'establecimiento',
      render: (text, record) => record.establecimiento?.nombre,
    },
    {
      ellipsis: true,
      title: 'Cultivo',
      dataIndex: 'cultivo',
      render: (text, record) => record.cultivo?.nombre,
    },
  ];

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <SearchOutlined onClick={(e) => handleView(record)} />
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 90,
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
      render: (text) =>
        text ? dayjs(convertDate(text)).format('DD/MM/YYYY') : '',
    },

    {
      width: 200,
      ellipsis: true,
      title: 'Establecimiento',
      dataIndex: 'establecimiento_nombre',
      sorter: (a, b) =>
        a.establecimiento_nombre?.localeCompare(b.establecimiento_nombre),
      search: true,
      render: (text, record) => (
        <span className="hover-bold-link" onClick={() => handleView(record)}>
          {text}
        </span>
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Cultivo',
      dataIndex: 'cultivo',
      render: (text, record) => (
        <span className="hover-bold-link" onClick={() => handleView(record)}>
          {record.cultivo?.nombre}
        </span>
      ),
      onFilter: (value, record) => {
        return record.cultivo_id === value;
      },
      sorter: (a, b) => a.cultivo?.nombre?.localeCompare(b.cultivo?.nombre),
      filterMultiple: true,
      filters: cultivo.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      title: 'Sociedad',
      dataIndex: 'sociedad_nombre',
      render: (text) => (text ? <Tag color="blue">{text}</Tag> : null),
    },
    {
      title: 'Aportantes',
      dataIndex: 'inversores',
      render: (inversores) => {
        if (!inversores || inversores.length === 0) return null;
        return inversores.map((inv) => (
          <Tag
            color="cyan"
            key={inv.id || inv.inversor_id}
            style={{ marginBottom: 4 }}
          >
            {inv.inversor_nombre}
          </Tag>
        ));
      },
    },
  ];
  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={stateData.list.data}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
          // cssStyle={!!campanaId}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar Actividad
            </Button>
            <Button
              type="primary"
              icon={<SelectOutlined />}
              size="small"
              style={{ marginLeft: '3px' }}
              onClick={(e) => handleRestore()}
            >
              Recuperar
            </Button>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <ActividadEditor
          id={rowEdit.id}
          parentId={id}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
      {showRestore ? (
        <RestorePopup
          columns={restoreColumns}
          data={stateData.deleted.data}
          onCancel={handleRestoreCancel}
          onOk={handleRestoreOk}
          loading={
            stateData.deleted.status === callStatus.LIST_DELETED_IN_PROCESS
          }
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { actividad, establecimiento, cultivo, campana } = state;
  const stateData = actividad;
  const parent = campana;
  return {
    stateData,
    establecimiento,
    cultivo,
    parent,
  };
};
export default connect(mapStateToProps)(withRouter(ActividadList));
